import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
  PercentageField,
} from '../../../commons/DataTable';
import SignalmanField from '../../../commons/DataTable/SignalmanField';
import FieldIafNumber from '../../../commons/DataTable/FieldIafNumber';

function SignalsTable({ data, total, offset, limit, onFilter }) {
  const [t] = useTranslation('SIGNALS');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <SignalmanField
        title="Ruolo"
        source="signalmanPosition"
        className="text-left"
      />
      <Field
        title="Segnalatore"
        source="signalman.businessName"
        className="text-left"
      />
      <Field
        title="Segnalatore P.iva/Codice Fiscale"
        source="signalman.taxCode"
        className="text-left"
      />
      <Field
        title="Beneficiario"
        source="adminInfo.businessName"
        className="text-left"
      />
      <Field
        title="Beneficiario P.iva/Codice Fiscale"
        source="adminInfo.taxCode"
        className="text-left"
      />
      <DateTimeField
        title="Data rendicontazione"
        source="accountabilityDate"
        className="text-left"
        format="DD/MM/YYYY"
      />
      <CurrencyField
        title="Totale fattura"
        source="estimate"
        className="txt-table-right"
      />
      <PercentageField
        title="Quota Da Ricevere %"
        source="calculateAdminPerc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota Da Ricevere"
        source="calculatedAdminShare"
        className="txt-table-right"
      />
      <FieldIafNumber
        title="Numero IAF"
        className="txt-table-right"
        source="iaf.number"
      />
      <Field
        title="Note"
        source="notes"
        className="text-left"
        style={{
          minWidth: '200px',
          maxWidth: '300px',
          whiteSpace: 'normal',
          overflowWrap: 'break-word',
        }}
      />
    </DataTable>
  );
}
export default SignalsTable;
